import { Entry } from './entry';

export interface All {
  all: Entry[];
}

export function isAll(rule: Entry): rule is All {
  return Object.prototype.hasOwnProperty.call(rule, 'all');
}
